import { BankruptcyStatusBadge } from '@/modules/tools/bankruptcy/components/BankruptcyStatusBadge'
import type { FilingDetail } from '@/modules/tools/bankruptcy/stores/types'
import { currencyFromCents, formatDate, formatNumber, fromNow } from '@/utils'
import { Stat } from './Stat'

export const ScreeningResults = ({ filing }: { filing: FilingDetail }) => {
  const isScreened = !!filing.screenedAt

  return (
    <div className="space-y-4 rounded-lg border p-4">
      <div className="grid grid-cols-2 gap-x-10 gap-y-4 sm:grid-cols-4">
        <Stat
          label="Case status"
          isMuted={!isScreened}
          value={
            isScreened ? <BankruptcyStatusBadge status={filing.status} /> : '—'
          }
        />
        <Stat
          label="Filing date"
          isMuted={!isScreened}
          value={filing.filedOn ? formatDate(filing.filedOn) : '—'}
        />
        <Stat
          label="Est. proceeds"
          isMuted={!isScreened}
          value={
            isScreened
              ? currencyFromCents(filing.estimatedDistributionCents)
              : '—'
          }
        />
        <Stat
          label="Est. §326 cap"
          isMuted={!isScreened}
          value={
            isScreened
              ? currencyFromCents(filing.estimatedCommissionCents)
              : '—'
          }
        />
      </div>

      <p className="border-t pt-3 text-muted-foreground text-xs">
        {isScreened
          ? `Screened ${fromNow(filing.screenedAt ?? undefined)} ago from ${formatNumber(filing.numberOfPages)} pages.`
          : 'Empty until you screen the case.'}
      </p>
    </div>
  )
}
